module.exports = __webpack_public_path__ + "static/img/logo-ipaam-carteira.b50a559b.png";